import React, { createContext, useEffect, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import Page from '../../../Common/Page';
import useTranslation from '../../../../util/hooks/useTranslation';
import useAsync from '../../../../util/hooks/useAsync';
import { getSelectedFilterApi } from '../../../../api/filter';
import reducer, { initialState, setEditMode, setOriginFilter } from './reducer';
import { useSelector } from 'react-redux';
import FilterPreview from './FilterPreview';
import DetailView from './View';

export const FilterDetailStateContext = createContext();
export const FilterDetailDispatchContext = createContext();

const FilterDetail = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const { editComplete } = state;
    const t = useTranslation('Filter');
    const { filterNum } = useParams();

    const { promise: getFilterInfo } = useAsync({
        promise: getSelectedFilterApi,
        resolve: res => {
            dispatch(setOriginFilter(res));
        },
    });

    useEffect(() => {
        if (filterNum) {
            getFilterInfo({ filterNum: Number(filterNum) });
        } else {
            dispatch(setOriginFilter(initialState.origin));
            dispatch(setEditMode(true));
        }
        return () => {
            dispatch(setOriginFilter(initialState.origin));
        };
    }, [filterNum]);

    return (
        <FilterDetailDispatchContext.Provider value={dispatch}>
            <FilterDetailStateContext.Provider value={state}>
                <Page menuPath={[t('Filters', 'Menu'), t('Filter Detail', 'Menu')]} className={'h-100'}>
                    <DetailView />
                    <FilterPreview />
                </Page>
            </FilterDetailStateContext.Provider>
        </FilterDetailDispatchContext.Provider>
    );
};

export default FilterDetail;
